import { rxTaskFactory } from 'src/js/helper/mobx-tasks';
import { RebootResponse } from 'src/js/model/api/response/reboot-response';
import { apiClient } from 'src/js/api';
import { SameTypeNetworkTaskGenerator } from 'src/js/util/global-type';

export const createRebootTask: SameTypeNetworkTaskGenerator<RebootResponse> = () =>
  rxTaskFactory(() => apiClient.settingsController.reboot());
